"use strict";
var ApiCoverage = (function () {
    function ApiCoverage() {
    }
    return ApiCoverage;
}());
exports.ApiCoverage = ApiCoverage;
//# sourceMappingURL=D:/a/1/s/base/src/models/api-coverage.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-coverage.model.js